import { Tag, Tooltip } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import "./styles.less"

// Due-date pill. Renders as a standard antd Tag (same as the Status / Flag tags)
// so the table reads consistently. Red < 48h or overdue, gold < 7d, default
// otherwise. Hover shows the exact response deadline.
const TONE_COLOR = { red: "red", amber: "gold", neutral: "default" }

const DeadlinePill = ({ due_by }) => {
  const { t } = useTranslation()
  if (!due_by) return null

  const due = dayjs(due_by)
  const hours = due.diff(dayjs(), "hour")

  let tone = "neutral"
  let label
  if (hours <= 0) {
    tone = "red"
    label = t("Overdue")
  } else if (hours < 48) {
    tone = "red"
    label = t("_n_h left", { n: hours })
  } else if (hours < 24 * 7) {
    tone = "amber"
    label = t("_n_d left", { n: Math.round(hours / 24) })
  } else {
    label = t("_n_d left", { n: Math.round(hours / 24) })
  }

  return (
    <Tooltip title={t("Response due _date_", { date: due.format("DD MMM YYYY HH:mm") })}>
      <Tag className="deadline-pill-tag" color={TONE_COLOR[tone]} style={{ marginInlineEnd: 0 }}>
        {label}
      </Tag>
    </Tooltip>
  )
}

export default DeadlinePill
